import { render, staticRenderFns } from "./ExpressOrder.vue?vue&type=template&id=011ca59c&scoped=true&"
import script from "./ExpressOrder.vue?vue&type=script&lang=js&"
export * from "./ExpressOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ca59c",
  null
  
)

export default component.exports